export default __webpack_public_path__ + "static/media/PPI-pools-017.8c56b445.jpg";